import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CommmonService } from 'src/app/utils/common.service';
import { RequestsService } from 'src/app/home/services/requests.service';

@Component({
  selector: 'app-side-bar-profile',
  templateUrl: './side-bar-profile.component.html',
  styleUrls: ['./side-bar-profile.component.scss'],
})
export class SideBarProfileComponent implements OnInit {
  isSizeMobile = false;
  superAdmin = false;
  second_approver = false;
  userAdmin = false;

  pending_approval = 0;
  pending_approval_loading = true;

  // Control del menú plegable de reportes
  reportsMenuOpen = false;

  // Nuevo array para el menú filtrado que se usa en el template
  filteredAdminProfile: any[] = [];

  // Arreglo con todas las opciones, ordenado según la imagen adjunta (Requisito 4)
  adminProfile: any = [
    { icon: '/assets/icono/icon-profiles-1.svg', name: 'Solicitudes', route: 'admin/requests' },
    { icon: '/assets/icono/Icons_Admin sidebar.svg', name: 'Reembolso FALP', route: 'admin/refund' },
    { icon: '/assets/icono/icon-profiles-5.svg', name: 'Segunda Aprobación', route: 'admin/requests/second-approver' },
    { icon: '/assets/icono/icon-profiles-9.svg', name: 'Préstamo Compañía', route: 'admin/company-loan' },
    { icon: '/assets/icono/icon-profiles-3.svg', name: 'Beneficios', route: 'admin/benefits' },
    { icon: '/assets/icono/icon-profiles-4.svg', name: 'Categorías', route: 'admin/categories' },
    { icon: '/assets/icono/icon-profiles-1.svg', name: 'Solicitudes Históricas', route: 'admin/historical-requests' },
    
    // Grupo de Reportes plegable
    {
      icon: '/assets/icono/icon-profiles-5.svg',
      name: 'Reportes',
      isGroup: true,
      children: [
        {
          icon: '/assets/icono/icon-profiles-5.svg',
          name: 'Reporte Detalle Solicitudes Usuarios',
          route: 'admin/users',
        },
        {
          icon: '/assets/icono/icon-profiles-5.svg',
          name: 'Reporte Seguro Complementario BCI',
          route: 'admin/reporte/seguro-complementario',
        },
        {
          icon: '/assets/icono/icon-profiles-5.svg',
          name: 'Reporte Gimnasio',
          route: 'admin/report/gym',
        },
        {
          icon: '/assets/icono/icon-profiles-5.svg',
          name: 'Reporte Beneficios',
          route: 'admin/reports/benefits',
        },
      ],
    },

    { icon: '/assets/icono/icon-salud.svg', name: 'Crédito Médico Salud y Dental', route: 'admin/health' },
    { icon: '/assets/icono/icon-profiles-5.svg', name: 'Configurar Segundo Aprobador Beneficios', route: 'admin/config/second-approver' },
    { icon: '/assets/icono/icon-profiles-6.svg', name: 'Mantenedores', route: 'admin/mantenedores' },
  ];

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private common_service: CommmonService,
    private request_service: RequestsService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.validateUserAdmin();
    // Ejecutar el filtro de menú después de validar roles
    this.filterAdminProfile();

    try {
      this.pending_approval_loading = true;
      const requests = await this.request_service.get_requests_pending_approval();
      this.pending_approval = Array.isArray(requests) ? requests.length : 0;
    } catch (e) {
      console.error('Error obteniendo pendientes:', e);
      this.pending_approval = 0;
    } finally {
      this.pending_approval_loading = false;
    }

    this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
    });
  }

  /**
   * Aplica la lógica de filtrado para determinar qué opciones del menú mostrar.
   * Se muestra si el usuario es SuperAdmin o UserAdmin Y cumple con las reglas 2 y 3.
   */
  filterAdminProfile() {
    if (this.superAdmin || this.userAdmin) {
      this.filteredAdminProfile = this.adminProfile.filter((profile: any) => {
        const isSecondApproverMenu =
          profile.name === 'Segunda Aprobación' ||
          profile.name === 'Configurar Segundo Aprobador Beneficios';

        // Los grupos (como "Reportes") no tienen lógica especial de segundo aprobador
        if (profile.isGroup) {
          return true;
        }

        // Regla 3: Si es una opción de segundo aprobador, solo se muestra si second_approver es true.
        if (isSecondApproverMenu) {
          return this.second_approver;
        }

        // Regla 2: Si no es una opción de segundo aprobador (es decir, es una opción base), se muestra.
        // Esto cubre todos los demás menús.
        return true;
      });
    } else {
      this.filteredAdminProfile = []; // No es admin, no se muestra el menú de gestores.
    }
  }

  selectTab(route: string) {
    if (!route) {
      return;
    }
    this.router.navigate([route]);
  }

    toggleReportsMenu() {
    this.reportsMenuOpen = !this.reportsMenuOpen;
  }

  async validateUserAdmin() {
    const active_user = JSON.parse(this.common_service.getItemSessionStorage('id_token_claims_obj') ?? '{}');
    this.userAdmin = active_user.roles && active_user.roles.some((role: any) => role.startsWith('ADMIN_'));
    this.superAdmin = active_user.roles && active_user.roles.includes('SUPER_ADMIN');
    this.second_approver = active_user.roles && active_user.roles.includes('SEGUNDO_APROBADOR');
  }
}